<div class="page-content">
    <div class="body-data">
        <div class="main">
            <div class="heading">
                <div class="h6">
                    <span class="text-heading">Material</span>
                    <div class="button">
                        <button class="bor-orange" [routerLink]="['/admin/procure/add-quote']" *ngIf="isRMS">Get Quote</button>
                    </div>
                </div>
            </div>
            <div class="tabs col-md-6">
                <mat-tab-group (selectedTabChange)="tabChange($event)">
                    <mat-tab>
                        <ng-template mat-tab-label *ngIf="isRMS">
                            <p class="label">Quotes <img src="assets/svg/Ellipse 860.svg" alt=""><span>{{quoteCount}}</span></p>
                        </ng-template>
                        <ng-template mat-tab-label *ngIf="!isRMS">
                            <p class="label">Bids <img src="assets/svg/Ellipse 860.svg" alt=""><span>{{bidCount}}</span></p>
                        </ng-template>
                    </mat-tab>
                    <mat-tab>
                        <ng-template mat-tab-label *ngIf="isRMS">
                            <p class="label">Orders <img src="assets/svg/Ellipse 860.svg" alt=""><span>{{partnerOrderCount}}</span></p>
                        </ng-template>
                        <ng-template mat-tab-label *ngIf="!isRMS">
                            <p class="label">Orders <img src="assets/svg/Ellipse 860.svg" alt=""><span>{{supplierOrderCount}}</span></p>
                        </ng-template>
                    </mat-tab>
                </mat-tab-group>
            </div>
            <div class="content">
                <!-- <div class="table">
               <mat-table [dataSource]="dataSource" matSort>

                    <ng-container matColumnDef="issue_date">
                        <mat-header-cell *matHeaderCellDef mat-sort-header class="light-text">ISSUE DATE</mat-header-cell>
                        <mat-cell *matCellDef="let element">{{element.issue_date}}</mat-cell>
                    </ng-container>
                   
                  

                   
                </mat-table>
                </div> -->
                <div class="d-flex flex-column clsbidtable mt-3">
                    <div class="moving-cart-items">
                        <div class="cart-heading mb-2">
                            <div class="col-md-2">
                                <p>Date and time.</p>
                            </div>
                            <div class="col-md-2">
                                <p *ngIf="tab_index === 0 && isRMS">Quote No</p>
                                <p *ngIf="tab_index === 0 && !isRMS">Bid Code</p>
                                <p *ngIf="tab_index === 1">Order No</p>
                            </div>

                            <!-- <div class="col-md-1"> 
                                <p>Type</p>
                            </div> -->
                            <!-- <div class="col-md-1">  -->
                            <p> Material</p>
                            <!-- </div> -->
                            <div class="col-md-1">
                                <p *ngIf="isRMS">Qty(in tonn)</p>
                                <p *ngIf="!isRMS">Quote ID</p>
                            </div>
                            <div class="col-md-1">
                                <p *ngIf="isRMS">Shipping Terms</p>
                                <p *ngIf="!isRMS">No of Items</p>
                            </div>
                            <div class="col-md-1">
                                <p *ngIf="isRMS">Payment Terms</p>
                                <p *ngIf="!isRMS">Total Cost</p>
                            </div>
                            <div class="col-md-2">
                                <p *ngIf="isRMS">Price</p>
                                <p *ngIf="!isRMS">Total Tax</p>
                            </div>
                            <div class="col-md-1">
                                <p>Status</p>
                            </div>
                        </div>
                        <div class="cart-data d-flex pointer" *ngFor="let list of materialList"
                            (click)="editPage(list)">
                            <div class="text-data col-md-2">
                                <p class=" no-margin-top">
                                    {{moment.utc(list.deliverydate).format('DD-MMM-YYYY')}}
                                </p>
                            </div>
                            <div class="col-md-2">
                                <p class=" no-margin" *ngIf="tab_index === 0 && isRMS">
                                    {{list?.quotecode}}
                                </p>
                                <p class=" no-margin" *ngIf="tab_index === 0 && !isRMS">
                                    {{list?.bidcode}}
                                </p>
                                <p class=" no-margin" *ngIf="tab_index === 1">
                                    {{list?.ordercode}}
                                </p>
                            </div>
                            <!-- <div class="col-md-1">
                                    <p class=" no-margin">
                                    Flat
                                    </p>
                                </div> -->
                            <!-- <div class="col-md-1"> -->
                            <p class=" no-margin">
                                SS304
                            </p>
                            <!-- </div> -->
                            <div class="col-md-1">
                                <p class=" no-margin" *ngIf="isRMS && tab_index === 0">
                                    {{list?.quantity}}
                                </p>
                                <p class=" no-margin" *ngIf="!isRMS && tab_index === 0">
                                    {{list?.quoteorderid}}
                                </p>
                                <p class=" no-margin" *ngIf="tab_index === 1">
                                    {{list?.quantity}}
                                </p>
                            </div>
                            <div class="col-md-1">
                                <p class=" no-margin" *ngIf="tab_index === 0 && isRMS">
                                    {{list?.shipmentterm}}
                                </p>
                                <p class=" no-margin" *ngIf="!isRMS && tab_index === 0">
                                    {{list?.bidItems?.length}}
                                </p>
                                <p class=" no-margin" *ngIf="tab_index === 1">
                                    {{list?.shipmentterm}}
                                </p>
                            </div>
                            <div class="col-md-1">
                                <p class=" no-margin" *ngIf="tab_index === 0 && isRMS">
                                    {{list?.paymentterms}}
                                </p>
                                <p class=" no-margin" *ngIf="tab_index === 0 && !isRMS">
                                    {{list?.totalcost}}
                                </p>
                                <p class=" no-margin" *ngIf="tab_index === 1">
                                    {{list?.paymentterms}}
                                </p>
                            </div>
                            <div class="col-md-2">
                                <p class=" no-margin">
                                    {{list?.currency}} {{list?.totalcost}}
                                </p>
                            </div>
                            <div class="col-md-1">
                                <p class=" no-margin" *ngIf="tab_index === 0 && isRMS">
                                    {{list?.quotestatus}}
                                </p>
                                <p class=" no-margin" *ngIf="tab_index === 0 && !isRMS">
                                    {{list?.bidstatus}}
                                </p>
                                <p class=" no-margin" *ngIf="tab_index === 1">
                                    {{list?.orderstatus}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>